module.exports = __webpack_public_path__ + "static/img/84.73dffd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/84.png
// module id = 4hF3
// module chunks = 1